import { commonSlice, store } from "../../../store";
import { DriversRow } from "../../../api";
import { shiftMonitoringSlice } from "../../../features/ShiftMonitoring/store";

export const selectShiftOffice = async (officeId: number): Promise<void> => {
    store.dispatch(shiftMonitoringSlice.actions.update_office_id(officeId));
};

export const selectDriver = async (
    driver: DriversRow | null
): Promise<void> => {
    if (driver) {
        store.dispatch(
            shiftMonitoringSlice.actions.update_driver_ids([driver.driverId!])
        );
        store.dispatch(commonSlice.actions.updateSelectedDriver(driver));
    } else {
        store.dispatch(shiftMonitoringSlice.actions.update_driver_ids([]));
        store.dispatch(commonSlice.actions.updateSelectedDriver(null));
    }
};

export const selectStartDate = async (startDate: string): Promise<void> => {
    store.dispatch(shiftMonitoringSlice.actions.update_start_date(startDate));
};

export const selectEndDate = async (endDate: string): Promise<void> => {
    store.dispatch(shiftMonitoringSlice.actions.update_end_date(endDate));
};

export const selectNeedGuidance = async (selector: boolean): Promise<void> => {
    store.dispatch(
        shiftMonitoringSlice.actions.update_need_guidance_only(selector)
    );
};
